
/* CSS */
import "../../../../styles/printSize.css";

/* HOOKS */
import { useAuth } from "../../../../contexts/AuthContext";

/* UTILS */
import DateFormatter from "../../../../utils/dateFormatterUtils";
import TitleCase from "../../../../utils/titleCaseUtils";
import titleCaseString from "../../../../utils/titleCaseUtils";
import { ImageURLToBase64 } from '../../../../utils/ImageURLToBase64';


import { useEffect, useState, useRef } from "react";
import { useParams } from "react-router-dom";


const NotaryAcknowledgmentForVirtual = ({ formData, mode = "IEN", dateReleased}) => {



    console.log("cachedTransactionsformData", formData);

    const { user } = useAuth();
    console.log("user", user.signature);
    
    const lawyerSignature = localStorage.getItem('lawyer_signature_base64');
 

 

    const { mid, id, apitransactionid } = useParams();

 


    const lawyerPhoto     = localStorage.getItem(`notary_image_${id}`);



    //   CONVER LINK PHOTO
    useEffect(() => {
        const convertImageToBase64 = async (imageUrl, mimeType = 'image/jpeg') => {
            const response = await fetch(imageUrl);
            const arrayBuffer = await response.arrayBuffer();

            const blob = new Blob([arrayBuffer], { type: mimeType }); // Force correct MIME
            return await new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.onloadend = () => resolve(reader.result); // Will now use correct type
                reader.onerror = reject;
                reader.readAsDataURL(blob);
            });
        };



        const updateWitnessesWithBase64 = async () => {
            const witnessKey = `witnesses_image_${id}`;
            const witnessArray = JSON.parse(localStorage.getItem(witnessKey) || '[]');

            if (witnessArray.length === 0) return;

            const updatedArray = await Promise.all(
                witnessArray.map(async (entry) => {
                    const witnessImageKey = Object.keys(entry).find(
                        (key) => key.startsWith('witness_') && !key.endsWith('_name')
                    );

                    const signatureKey = `${witnessImageKey}_signature`;
                    const signatureUrl = entry[signatureKey];

                    if (!signatureUrl || signatureUrl.startsWith('data:image')) {
                        // Already base64 or empty, skip conversion
                        return entry;
                    }

                    try {

                        const base64 = await convertImageToBase64(
                            signatureUrl,
                            'image/jpeg' // or 'image/png'
                        );
                        return {
                            ...entry,
                            [signatureKey]: base64, // Replace URL with base64 string
                        };
                    } catch (error) {
                        console.error('Failed to convert signature to base64:', error);
                        return entry; // Keep original if conversion fails
                    }
                })
            );

            // Save updated data back to localStorage
            localStorage.setItem(witnessKey, JSON.stringify(updatedArray));
        };

        updateWitnessesWithBase64();
    }, [formData]);



   




    const enp_roll_no = user.enp_roll_no;
    const enp_commission_no = user.enp_commission_no;
    const enp_ptr_no = user.enp_ptr_no;
    const enp_ptr_issued_place = user.enp_ptr_issued_place;
    const enp_ibp_no = user.enp_ibp_no;
    const enp_email = user.enp_email;
    const enp_address = user.enp_address;
    const enp_compliance_no = user.enp_compliance_no;
    const enp_notary_name = user.enp_notary_name;


    const enp_province = user.province;
    const enp_municipality = user.municipality;
    const enp_barangay = user.barangay;

    console.log(user.enp_commission_expiry_date);

    const enp_commission_expiry_date = new Date(user.enp_commission_expiry_date).toLocaleDateString("en-US", {
        year: "numeric",
        month: "short",
        day: "numeric",
        timeZone: "Asia/Manila",
    });
    const enp_ptr_issued_date = new Date(user.enp_ptr_issued_date).toLocaleDateString("en-US", {
        year: "numeric",
        month: "short",
        day: "numeric",
        timeZone: "Asia/Manila",
    });
    const enp_compliance_issued_date = new Date(user.enp_compliance_issued_date).toLocaleDateString("en-US", {
        year: "numeric",
        month: "short",
        day: "numeric",
        timeZone: "Asia/Manila",
    });

    const lawyerFullName = `${user.first_name} ${user.middle_name ?? ""} ${user.last_name}`;

    const fullName = `${formData.firstName} ${formData.middleName ?? ""} ${formData.lastName} ${formData.suffix ?? ""}`;
    const secondPartyFullName = `${formData.secondPartyFirstName} ${formData.secondPartyMiddleName ?? ""} ${formData.secondPartyLastName} ${formData.secondPartySuffix ?? ""}`;


    console.log("dateIssuedfullName",formData);


const formattedDateIssued = new Date(formData.dateIssued + "T00:00:00").toLocaleDateString("en-US", {
    year: "numeric",
    month: "short", // Abbreviated month (e.g., 'Jan')
    day: "numeric",
    timeZone: "Asia/Manila",
});
 

    const issuedDate = formData.secondPartyDateIssued
        ? new Date(formData.secondPartyDateIssued)
        : new Date();

    const formattedDateIssuedSecondParty = issuedDate.toLocaleDateString("en-US", {
        year: "numeric",
        month: "short",
        day: "numeric",
        timeZone: "Asia/Manila",
    });





    const localStorageNotaryImage = localStorage.getItem(`notary_image_` + id);
    const localStoragePrincipal = localStorage.getItem(`principal_image_` + id);
    const localStorageSecondaryPrincipal = localStorage.getItem(`secondary_principal_image_` + id);
    const localStorageWitnesses = localStorage.getItem(`witness_image_` + id);



    return (
        <>
            <div className="a4-container text-times-new-roman p-5 position-relative bg-none">
                <div style={{
                        position: "absolute",
                        top: "7%",
                        left: "5%",
                        right: "5%",
                        bottom: "10%", 
                        //backgroundImage: "url('/iusevolutione/assets/img/iusevolutione/enotaryBg.png')",
                        backgroundSize: "cover",
                        backgroundRepeat: "no-repeat",
                        backgroundPosition: "center",
                        opacity: 0.1,
                        zIndex: 1,
                        height: "80%",
                        width: "100%",
                    }} />

                <div style={{ position: "relative", zIndex: 10, padding: "20px", }}>
                   <div className="d-flex justify-content-between flex-row">
                        <div>
                            <div className="mb-2 d-flex flex-column">
                                <span>Republic of the Philippines )</span>
                                <span className="fw-medium">
                                    City/Municipality of {TitleCase(enp_municipality)} ) S.S.
                                </span>
                            </div>

                              <img
                                    src="/iusevolutione/assets/img/iusevolutione/logoWithTitle.png"
                                    alt="Logo"
                                    className="img-fluid"
                                    style={{ width: 180, height: 60 }}
                                />
                        </div>
                        <div>

                                  <div className="text-start" >
                                    <div className="d-inline-block text-center">
                                        <img
                                            src={`data:image/png;base64,${formData.qr}`}
                                            alt="QR"
                                            className="img-fluid"
                                            style={{ width: 128, height: 128 }}
                                        />
                                        <div>SERIAL NUMBER:</div>
                                        <div className="fw-bold">{formData.transactionId}</div>
                                    </div>
                                </div>

                        </div>
                    </div>


                    <div className="text-center fw-bold mb-0">ACKNOWLEDGEMENT</div>

                    <p className="mt-5">

                        On this <b>{DateFormatter(dateReleased, 'Day of Month, YYYY')}</b>, before me
                        , a duly commissioned <b>Electronic Notary Public</b> in and for the{" "}
                        <b>Philippines</b>, personally appeared via video conference:
                    </p>

                    <table className="table table-bordered  text-center mt-4" style={{border:"1px solid gray",color:"black"}}>
                        <thead>
                            <tr>
                               <th>
                                    <i className="fw-bold"  style={{color:"black"}}>Name of Signatory</i>
                                </th>
                                <th>
                                    <i className="fw-bold"  style={{color:"black"}}>Issued ID</i>
                                </th>
                                <th>
                                    <i className="fw-bold"  style={{color:"black"}}>ID No./ Date Issued</i>
                                </th>
                            </tr>
                        </thead>
                        <tbody>

                            {formData.firstName &&
                                <tr>
                                    <td>
                                        <div  style={{color:"black"}}>
                                            {TitleCase(fullName.toUpperCase())}
                                        </div>
                                    </td>
                                    <td>
                                        <div  style={{color:"black"}}>
                                            {formData.idType?.toUpperCase()}
                                        </div>
                                    </td>
                                    <td>
                                        <div  style={{color:"black"}}>
                                            {formData.idNo} / {formattedDateIssued}
                                        </div>
                                    </td>
                                </tr>
                            }


                            {formData.secondPartyFirstName &&

                                <tr>
                                    <td> <div style={{color:"black"}}> {TitleCase(secondPartyFullName.toUpperCase())} </div> </td>
                                    <td> <div style={{color:"black"}}> {formData.secondPartyIdType?.toUpperCase()} </div> </td>
                                    <td> <div style={{color:"black"}}> {formData.secondPartyIdNo} / {formattedDateIssuedSecondParty} </div> </td>
                                </tr>

                            }


                        </tbody>
                    </table>

                    <p className="mt-2">
                        who is known to me to be the same person who executed the foregoing
                        electronic document.
                    </p>
                    <p className="mt-2">
                        During the videoconference, the principal affixed his/her electronic
                        signature through the <b>Electronic Notarization Facility (ENF)</b> in
                        my full view, confirmed that the signature was voluntarily affixed for
                        the purposes stated therein, and declared that he/she electronically
                        signed the document as his/her free and voluntary act and deed.
                    </p>

                    <p className="mt-2">
                        This document was electronically notarized via <b>[Mode: {mode}]</b>,
                        in accordance with the Rules on Electronic Notarization and existing
                        laws.
                    </p>

                    <p className="fw-bold">
                        IN WITNESS WHEREOF, I hereunto affix my electronic notarial seal this
                        <b className="ms-1">{DateFormatter(dateReleased, 'MM DD, YYYY')}</b> at <b>{TitleCase(enp_municipality)}, Philippines</b>.
                    </p>



                    <div className="row fw-bold">
                        <div className="col-4">
                            <div className="mt-4">
                                <p className="m-0">Doc. No.: {formData.documentNo ? formData.documentNo : '______'} </p>
                                <p className="m-0">Page No.: {formData.pageNo ? formData.pageNo : '______'} </p>
                                <p className="m-0">Book No.: {formData.bookNo ? formData.bookNo : '______'} </p>
                                <p className="m-0">Series of {DateFormatter(dateReleased, 'YYYY')}</p>
                            </div>
                        </div>


                        <div className="col-8">
                            <div className="d-flex flex-column align-items-center text-center mt-4  text-primary">
                                <div className="fw-bold">Atty. {TitleCase(lawyerFullName.toUpperCase())}</div>
                                <div>Electronic Notary Public</div>
                                <div className="d-flex d-inline-block">
                                    Roll of Attorney's No.:
                                    {enp_roll_no}
                                </div>
                                <div className="d-flex d-inline-block">
                                    Commission No.:
                                    {enp_commission_no}
                                </div>
                                <div className="d-flex d-inline-block">
                                    Commission Expiry Date:

                                    {enp_commission_expiry_date}
                                </div>
                                <div className="d-flex d-inline-block">
                                    PTR No.:
                                    {enp_ptr_no}
                                    , issued at <b className="ms-1">{enp_ptr_issued_place}</b>, on <b className="ms-1">{enp_ptr_issued_date}</b>
                                </div>
                                <div className="d-flex d-inline-block">
                                    IBP No.:
                                    {enp_ibp_no}
                                </div>
                                <div className="d-flex d-inline-block">
                                    Email:{enp_email}
                                </div>
                                <div className="d-flex d-inline-block">
                                    Office Address:
                                    {TitleCase(enp_address)}
                                </div>
                                <div className="d-flex d-inline-block">
                                    MCLE Compliance No.:
                                    {enp_compliance_no}
                                    , issued on <b className="ms-1"> {enp_compliance_issued_date}</b>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <img src="/iusevolutione/assets/img/iusevolutione/footer-logo.png" className="img-fluid m-0" style={{ position: 'absolute', bottom: 0,left:0}} />


            </div>


            <div className="a4-container text-times-new-roman p-5 position-relative bg-none" style={{
                height: "1208px", // Or any fixed value to match your page size
            }}>
                <div
                    style={{
                        position: "absolute",
                        top: "7%", // Centers the div vertically by setting the top to 10% (since height is 80%, 100% - 80% = 20%, so we divide it equally with 10% padding on top and bottom)
                        left: "5%", // Centers the div horizontally by setting the left to 5% (100% - 90% = 10%, so we divide it equally with 5% padding on both sides)
                        right: "5%",
                        bottom: "10%",
                        //backgroundImage: "url('/iusevolutione/assets/img/iusevolutione/enotaryBg.png')",
                        backgroundSize: "cover",
                        backgroundRepeat: "no-repeat",
                        backgroundPosition: "center",
                        opacity: 0.1,
                        zIndex: 1, // Ensures the background stays behind the content
                        height: "80%", // Height set to 80%
                        width: "100%", // Width set to 90%
                    }}
                />

                <div
                    style={{
                        position: "relative",
                        zIndex: 10,
                        padding: "20px",
                        height: "91%"
                    }}>

                     <div className="d-flex justify-content-between flex-row mb-4">
                        <div>
                            <div className="mb-4 d-flex flex-column">
                                <span className="fw-bold fs-5 ">ANNEX A</span>
                            </div>

                              <img
                                    src="/iusevolutione/assets/img/iusevolutione/logoWithTitle.png"
                                    alt="Logo"
                                    className="img-fluid"
                                    style={{ width: 180, height: 60 }}
                                />
                        </div>
                        <div>

                                  <div className="text-start" >
                                    <div className="d-inline-block text-center">
                                        <img
                                            src={`data:image/png;base64,${formData.qr}`}
                                            alt="QR"
                                            className="img-fluid"
                                            style={{ width: 128, height: 128 }}
                                        />
                                    </div>
                                </div>
                        </div>
                    </div>

                    <div className="row mb-4 mt-4">
                        <div className="col">

                            <div className="text-center">

 
                                {formData.lawyerImage &&
                                    <img
                                        // src={lawyerPhoto}
                                        src={lawyerPhoto}
                                        alt="Lawyer3"
                                        className="rounded border"
                                        height={275} width={180}
                                        style={{ objectFit: "cover",transform: 'scaleX(-1)' }}
                                    />
                                }

                                <div className="text-center d-flex flex-column align-items-center">
                                    <p className="fw-bold">NOTARY PUBLIC</p>
                                    {lawyerSignature &&
                                        <img src={lawyerSignature} alt={`Signature`} className="  rounded  w-220px  p-0 mt-n4" height={120} />
                                    }
                                    <p className=" text-center mt-n4" style={{ borderTop: "1px solid black" }}><b>Atty. {titleCaseString(lawyerFullName)}</b></p>
                                </div>


                            </div>

                        </div>

                        {formData.firstName &&
                            <div className="col">
                                <div className="text-center">
                                    {formData.principalImage &&
                                        <img
                                            src={`data:image/jpeg;base64,${formData.principalImage}`}
                                            alt={`Valid ID`} className="rounded"
                                            height={275} width={180}
                                            style={{ objectFit: "cover" }}
                                        />}

                                    <div className="text-center d-flex flex-column align-items-center">
                                        <p className="fw-bold">FIRST PARTY</p>
                                        {formData.principalImageSignature && <img src={formData.principalImageSignature} alt={`Signature`} className="  rounded  w-220px  p-0 mt-n4" height={120} />}
                                        <p className=" text-center mt-n4" style={{ borderTop: "1px solid black" }}><b>{titleCaseString(fullName)}</b></p>
                                    </div>
                                </div>
                            </div>
                        }

                        {formData.secondPartyPrincipalImage &&
                            <div className="col">
                                <div className="text-center">

                                    {formData.secondPartyPrincipalImage &&
                                        <img
                                            src={`data:image/jpeg;base64,${formData.secondPartyPrincipalImage}`}
                                            alt={`Valid ID`} className="rounded"
                                            height={275} width={180}
                                            style={{ objectFit: "cover" }}
                                        />}

                                    <div className="text-center d-flex flex-column align-items-center">
                                        <p className="mb-0"><b>SECOND PARTY</b></p>
                                        {formData.secondPartyPrincipalImageSignature && <img src={formData.secondPartyPrincipalImageSignature} alt={`Signature`} className="  rounded  w-220px  p-0 mt-n4" height={120} />}
                                        <p className=" text-center mt-n4" style={{ borderTop: "1px solid black" }}><b>{titleCaseString(secondPartyFullName)}</b></p>
                                    </div>

                                </div>
                            </div>
                        }



                    </div>


                    {(() => {

                        const storageKey = `witnesses_image_${id}`;
                        const storedWitnesses = JSON.parse(localStorage.getItem(storageKey) || '[]');

                        if (storedWitnesses.length === 0) {
                            return null; // Do not render anything
                        }

                        function normalizePhoneNumber(number) {
                            // Remove all non-digits first
                            const digitsOnly = number.replace(/\D/g, "");

                            if (digitsOnly.startsWith("0") && digitsOnly.length === 11) {
                                // e.g., "09976009063" ➜ "9976009063"
                                return digitsOnly.slice(1);
                            }

                            if (digitsOnly.startsWith("63") && digitsOnly.length === 12) {
                                // e.g., "639976000963" ➜ "9976009063"
                                return digitsOnly.slice(2);
                            }

                            if (digitsOnly.length === 10) {
                                // Already normalized
                                return digitsOnly;
                            }

                            // Return as-is if unrecognized format
                            return digitsOnly;
                        }

                        // Helper functions
                        function isPhoneNumber(value) {
                            return /^\d{11}$/.test(value);

                        }
                        function isEmail(value) {
                            return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
                        }



                        // Matching logic
                        const matchedWitnesses = formData.witnesses && formData.witnesses.map(witness => {


                            console.log("witness", witness);

                            const contact = witness.contactInfo;
                            let keySuffix;
                            let match;

                            if (isPhoneNumber(contact)) {
                                keySuffix = contact;
                                match = storedWitnesses.find(obj => obj[`witness_${keySuffix}_contact`] === contact);
                            } else if (isEmail(contact)) {
                                keySuffix = contact;
                                match = storedWitnesses.find(obj => obj[`witness_${keySuffix}_contact`] === contact);
                            }
                            if (match) {
                                return {
                                    contact_info: contact,
                                    signature: witness.participantSignaturePath,
                                    name: match[`witness_${keySuffix}_name`] || null,
                                    image: match[`witness_${keySuffix}`] || null,
                                };
                            }

                            return null;
                        }).filter(Boolean); // removes nulls

                        console.log("matchedWitnesses", matchedWitnesses);



                        // const witnessKey = `witnesses_image_${id}`;
                        // const witnessArray = JSON.parse(localStorage.getItem(witnessKey) || '[]');

                        if (matchedWitnesses && matchedWitnesses.length === 0) {
                            return null; // Do not render anything
                        }


                        return (
                            <div className="row mt-4">
                                <div className="fw-bold fs-4 mb-2">Witness/es</div>

                                {matchedWitnesses && matchedWitnesses.length > 0 && matchedWitnesses.slice(0, 3).map((witness, index) => {

                                    return (

                                        <div key={index} className="col text-center">
                                            {witness.image && (
                                                <img
                                                    src={`data:image/jpeg;base64,${witness.image}`}
                                                    alt="Witness"
                                                    className="rounded"
                                                    height={275}
                                                    width={180}
                                                    style={{ objectFit: "cover" }}
                                                />
                                            )}
                                            <div className="text-center d-flex flex-column align-items-center">
                                                <img src={witness.signature} alt={`Signature`} className="  rounded  w-220px  p-0 mt-n4" height={120} />
                                                <p className=" text-center mt-n4" style={{ borderTop: "1px solid black" }}><b>{titleCaseString(witness.name)}</b></p>
                                            </div>
                                        </div>




                                    );
                                })}
                            </div>
                        );

                    })()}



                </div>




                {/* <img
                    src="/iusevolutione/assets/img/iusevolutione/logoWithTitle.png"
                    alt="Logo"
                    className="img-fluid"
                    style={{ width: 170, height: 60, marginBottom: 40, position: "absolute", bottom: 0 }}
                />

                <img
                    src="/iusevolutione/assets/img/iusevolutione/enotaryFooter.png"
                    alt="Logo"
                    style={{ marginLeft: -55, position: "absolute", bottom: 0, width: "100%", height: "190px" }}
                /> */}


            </div>


            {(() => {
                const storageKey = `witnesses_image_${id}`;
                const storedWitnesses = JSON.parse(localStorage.getItem(storageKey) || '[]');

                if (storedWitnesses.length === 0) {
                    return null;
                }

                function normalizePhoneNumber(number) {
                    const digitsOnly = number.replace(/\D/g, "");

                    if (digitsOnly.startsWith("0") && digitsOnly.length === 11) {
                        return digitsOnly.slice(1);
                    }

                    if (digitsOnly.startsWith("63") && digitsOnly.length === 12) {
                        return digitsOnly.slice(2);
                    }

                    if (digitsOnly.length === 10) {
                        return digitsOnly;
                    }

                    return digitsOnly;
                }

                function isPhoneNumber(value) {
                    return /^\d{11}$/.test(value);
                }

                function isEmail(value) {
                    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
                }

                const matchedWitnesses = formData.witnesses && formData.witnesses.map(witness => {
                    const contact = witness.contactInfo;
                    let keySuffix;
                    let match;

                    if (isPhoneNumber(contact)) {
                        keySuffix = contact;
                        match = storedWitnesses.find(obj => obj[`witness_${keySuffix}_contact`] === contact);
                    } else if (isEmail(contact)) {
                        keySuffix = contact;
                        match = storedWitnesses.find(obj => obj[`witness_${keySuffix}_contact`] === contact);
                    }

                    if (match) {
                        return {
                            contact_info: contact,
                            signature: witness.participantSignaturePath,
                            name: match[`witness_${keySuffix}_name`] || null,
                            image: match[`witness_${keySuffix}`] || null,
                        };
                    }

                    return null;
                }).filter(Boolean);

                // ✅ Moved condition here, after `matchedWitnesses` is defined
                if (!matchedWitnesses || matchedWitnesses.length <= 3) {
                    return null;
                }

                return (
                    <div className="a4-container text-times-new-roman p-5 position-relative bg-none" style={{ height: "1208px" }}>
                        <div
                            style={{
                                position: "absolute",
                                top: "7%",
                                left: "5%",
                                right: "5%",
                                bottom: "10%",
                                //backgroundImage: "url('/iusevolutione/assets/img/iusevolutione/enotaryBg.png')",
                                backgroundSize: "cover",
                                backgroundRepeat: "no-repeat",
                                backgroundPosition: "center",
                                opacity: 0.1,
                                zIndex: 1,
                                height: "80%",
                            }}
                        />

                        <div style={{ position: "relative", zIndex: 10, padding: "20px", height: "100%", flex: 1 }}>
                            <div className="d-flex justify-content-between flex-row mb-4">
                                <div>
                                    <div className="mb-4 d-flex flex-column">
                                        <span className="fw-bold fs-5 ">ANNEX B</span>
                                    </div>

                                    <img
                                            src="/iusevolutione/assets/img/iusevolutione/logoWithTitle.png"
                                            alt="Logo"
                                            className="img-fluid"
                                            style={{ width: 180, height: 60 }}
                                        />
                                </div>
                                <div>
                                    <div className="text-start" >
                                        <div className="d-inline-block text-center">
                                            <img
                                                src={`data:image/png;base64,${formData.qr_code}`}
                                                alt="QR"
                                                className="img-fluid"
                                                style={{ width: 128, height: 128 }}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="row mt-4">
                                <div className="fw-bold fs-4 mb-2">Witness/es</div>



                                {matchedWitnesses.slice(3).map((witness, index) => (
                                    <div key={index + 3} className="col text-center">
                                        {witness.image && (
                                            <img
                                                src={`data:image/jpeg;base64,${witness.image}`}
                                                alt="Witness"
                                                className="rounded"
                                                height={275}
                                                width={180}
                                                style={{ objectFit: "cover" }}
                                            />
                                        )}
                                        <div className="text-center d-flex flex-column align-items-center">
                                            <img src={witness.signature} alt={`Signature`} className="  rounded  w-220px  p-0 mt-n4" height={120} />
                                            <p className=" text-center mt-n4" style={{ borderTop: "1px solid black" }}><b>{titleCaseString(witness.name)}</b></p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>

                        <img
                            src="/iusevolutione/assets/img/iusevolutione/logoWithTitle.png"
                            alt="Logo"
                            className="img-fluid d-none"
                            style={{ width: 170, height: 60, marginBottom: 40, position: "absolute", bottom: 0 }}
                        />

                        <img
                            src="/iusevolutione/assets/img/iusevolutione/enotaryFooter.png"
                            className=" d-none"
                            alt="Logo"
                            style={{ marginLeft: -55, position: "absolute", bottom: 0, width: "100%", height: "190px" }}
                        />
                    </div>
                );
            })()}
        
        </>
    );
};

export default NotaryAcknowledgmentForVirtual;
